import { Component } from '@angular/core';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-s-all-done-good',
    templateUrl: './s-all-done-good.component.html',
    styleUrls: ['./s-all-done-good.component.scss'],
    standalone: false
})
export class SAllDoneGoodComponent {
     isLoading = true;
     constructor(public generalService: GeneralService, public enrollmentService: EnrollmentService) { }

     wizardObj: IWizard = {
          steps: [
               { step: 1, text: 'Welcome' } as WizardSteps,
               { step: 2, text: 'Company Information' } as WizardSteps,
               { step: 3, text: 'User Accounts' } as WizardSteps,
               { step: 4, text: 'Review' } as WizardSteps,
               { step: 5, text: 'Contract Documents' } as WizardSteps,
               { step: 6, text: 'Submit' } as WizardSteps,
               { step: 7, text: 'Billing Information' } as WizardSteps
          ], 
          _cancelLinkRoute: '',
          backLinkRoute(currentPane: number) {;
            // not implimented
            return '';
          },
          continueLinkRoute(currentPane: number) {;
            // not implimented
            return '';
          },
          totalSteps: 1,
          type: 'enroll',
          visualProgressStep(currentPane: number) {;
            // not implimented
            return 1;
          }
     }

     ngOnInit(){
          this.enrollmentService.clearAll();
          setTimeout(() => this.scrollToTop(), 500);
          this.isLoading = false;
     }

     customizeAllDoneMessage() {
          let translatedText: string = this.generalService.getTranslation('COMPLETE_1');
          if (translatedText === undefined) {
              translatedText = this.generalService.getTranslation('COMPLETE_1');
          }
          return translatedText;
      }
  
      translate(translationTag:string) {
          let translatedText: string = this.generalService.getTranslation(translationTag)
          if (translatedText === undefined) {
              translatedText = this.generalService.getTranslation(translationTag);
          }
          return translatedText;
      }
  
      mounted() {
          window.onbeforeunload = null;
          document.getElementById('PSP-Home')?.focus();
      }
      
      scrollToTop() {
          window.scrollTo(0, 0);
      }
}
